module.exports = __webpack_public_path__ + "media/images/webpage/hotels/9494/plan4-1-decb9a0ebcba8bb31dd26d09a9bc0b6a.webp";